  // * Wraps text for defined length for table columns

export const wrapText = (text, maxLength) => {
  const regex = new RegExp(`.{1,${maxLength}}`, "g");
  return text.match(regex).join("\n");
};
